export const templateName = {
    INTEREST_CANDIDATES_NOTIFCATION: 'Interest Candidates Notifcation', // todo need check is used
    SEND_CANDIDATE_BACK_TO_REVIEW_NOTIFICATION: 'Candidate Back to Review', // todo need check is used
    SEND_CANDIDATES_BACK_TO_REVIEW_NOTIFICATION: 'Bulk Back to Review', // todo need check is used
    JOB_CANCELLED_NOTIFICATION: 'Job Cancelled', // todo need check is used
    START_AUTO_CONTACT: 'startAutoContact', // todo need check is used
    STOP_AUTO_CONTACT: 'stopAutoContact', // todo need check is used
    PROFILE_SUBMISSION: 'Profile Submission (Single profile)', //
    CREDIT_USAGE_TURN_OFF: 'Credit usage turn off', // todo need check is used
    CREDIT_USAGE_TURN_ON: 'Credit usage turn on', // todo need check is used
    REMAINING_CREDIT_BALANCE: '%Remaining Credit balance', // todo need check is used
    ZERO_CREDIT_BALANCE: '0 Credit balance', // todo need check is used
    CREDIT_BALANCE_UPDATE: 'Credit balance update', // todo need check is used
    AUTO_CONTACT_CAMPAIGN_PAUSED: 'Auto contact campaign paused', // todo need check is used
    AUTO_CONTACT_CAMPAIGN_RESUMED: 'Auto contact campaign resumed',
    REJECTION_REASON_OTHER: 'Rejection reason Other', // todo need check is used
    EMPLOYER_WELCOME_MESSAGE: 'Employer welcome message',
    INVITE_TEMPLATE_TE_1: 'Invite template TE 1',
    RE_INVITE_TEMPLATE_TE_1: 'Re invite template TE 1',
    INVITE_TEMPLATE_EMPREP_1: 'Invite template EMPREP 1',
    RE_INVITE_TEMPLATE_EMPREP_1: 'Re invite template EMPREP 1',
    AUTO_CAMPAIGN_PAUSED_EMAIL: 'AutoCampaign Paused email',
    AUTO_CAMPAIGN_ACTIVE_EMAIL: 'AutoCampaign Active email',
    REQUEST_PASSWORD_RESET: 'Request Password Reset',
    POSITION_FEEDBACK_REQUEST_TO_EMPLOYER_REP: 'Position feedback request to EmployerRep',
    CREDIT_USAGE_THIRD_MESSAGE: 'Credit usage >= x% (3 message)',
    CREDIT_USAGE_SECOND_MESSAGE: 'Credit usage >= x% (2 message)',
    CREDIT_USAGE_FIRST_MESSAGE: 'Credit usage >= x% (1 message)',
    CREDIT_EXPIRATION_DATE: 'Credit expiration date',
    EMPLOYER_SETTINGS_ATS_URL_SETTING_CHANGED: 'Employer Ats Url setting changed',
    ATS_SETTINGS_CHANGED: 'Ats Settings Changed',
    DELETE_EMPLOYER_REP: 'Delete Employer Rep',
    LINKEDIN_INMAIL_CONNECT_INVITE: 'LinkedIn InMail Connect Invite',
    TALENT_REJECT_POSITION_NEW: 'TALENT_REJECT_POSITION_NEW',
    TALENT_CONFIRM_POSITION_NEW: 'TALENT_CONFIRM_POSITION_NEW',
    AI_JOB_CALIBRATION_REQUEST: 'AI job calibration request',
};

export const templateTranslatedNames = {
    [templateName.EMPLOYER_WELCOME_MESSAGE]: 'TRANSLATED_TEMPLATE_NAME_EMPLOYER_WELCOME_MESSAGE',
    [templateName.AUTO_CAMPAIGN_PAUSED_EMAIL]: 'TRANSLATED_TEMPLATE_NAME_AUTO_CAMPAIGN_PAUSED_EMAIL',
    [templateName.AUTO_CAMPAIGN_ACTIVE_EMAIL]: 'TRANSLATED_TEMPLATE_NAME_AUTO_CAMPAIGN_ACTIVE_EMAIL',
    [templateName.REQUEST_PASSWORD_RESET]: 'TRANSLATED_TEMPLATE_NAME_REQUEST_PASSWORD_RESET',
    [templateName.POSITION_FEEDBACK_REQUEST_TO_EMPLOYER_REP]: 'TRANSLATED_TEMPLATE_NAME_POSITION_FEEDBACK_REQUEST_TO_EMPLOYER_REP',
    [templateName.CREDIT_USAGE_THIRD_MESSAGE]: 'TRANSLATED_TEMPLATE_NAME_CREDIT_USAGE_THIRD_MESSAGE',
    [templateName.CREDIT_USAGE_SECOND_MESSAGE]: 'TRANSLATED_TEMPLATE_NAME_CREDIT_USAGE_SECOND_MESSAGE',
    [templateName.CREDIT_USAGE_FIRST_MESSAGE]: 'TRANSLATED_TEMPLATE_NAME_CREDIT_USAGE_FIRST_MESSAGE',
    [templateName.CREDIT_EXPIRATION_DATE]: 'TRANSLATED_TEMPLATE_NAME_CREDIT_EXPIRATION_DATE',
    [templateName.EMPLOYER_SETTINGS_ATS_URL_SETTING_CHANGED]: 'TRANSLATED_TEMPLATE_NAME_EMPLOYER_SETTINGS_ATS_URL_SETTING_CHANGED',
    [templateName.ATS_SETTINGS_CHANGED]: 'TRANSLATED_TEMPLATE_NAME_ATS_SETTINGS_CHANGED',
    [templateName.DELETE_EMPLOYER_REP]: 'TRANSLATED_TEMPLATE_NAME_DELETE_EMPLOYER_REP',
    [templateName.RE_INVITE_TEMPLATE_EMPREP_1]: 'TRANSLATED_TEMPLATE_NAME_RE_INVITE_TEMPLATE_EMPREP_1',
    [templateName.INVITE_TEMPLATE_EMPREP_1]: 'TRANSLATED_TEMPLATE_NAME_INVITE_TEMPLATE_EMPREP_1',
    [templateName.RE_INVITE_TEMPLATE_TE_1]: 'TRANSLATED_TEMPLATE_NAME_RE_INVITE_TEMPLATE_TE_1',
    [templateName.INVITE_TEMPLATE_TE_1]: 'TRANSLATED_TEMPLATE_NAME_INVITE_TEMPLATE_TE_1',
    [templateName.EMPLOYER_WELCOME_MESSAGE]: 'TRANSLATED_TEMPLATE_NAME_EMPLOYER_WELCOME_MESSAGE',
    [templateName.LINKEDIN_INMAIL_CONNECT_INVITE]: 'TRANSLATED_TEMPLATE_NAME_LINKEDIN_INMAIL_CONNECT_INVITE',
    [templateName.TALENT_REJECT_POSITION_NEW]: 'TRANSLATED_TEMPLATE_NAME_TALENT_REJECT_POSITION_NEW',
    [templateName.TALENT_CONFIRM_POSITION_NEW]: 'TRANSLATED_TEMPLATE_NAME_TALENT_CONFIRM_POSITION_NEW',
    [templateName.AI_JOB_CALIBRATION_REQUEST]: 'TRANSLATED_TEMPLATE_NAME_AI_JOB_CALIBRATION_REQUEST',
    [templateName.PROFILE_SUBMISSION]: 'TRANSLATED_TEMPLATE_NAME_PROFILE_SUBMISSION',
};
